export const LANGUAGE_VERSIONS = {
  go: "1.21.0",
  python: "3.11.0",
  javascript: "18.12.0",
  java: "18.0.1",
  typescript: "5.0.0",
  c: "11",
  cpp: "20",
  rust: "1.70.0",
  bash: "5.1.16",
};
